angular.module('iconoglobe').controller('IDCtrl', IDCtrl);
IDCtrl.$inject = ['$scope', '$rootScope', '$http', '$stateParams', '$filter', '$window', '$timeout', '$location', '$upload', 'localStorageService', 'MetaUtilService', '$q', "$document", "$uibModal", "metaHelper", "cookieStore", "LOCALES", 'debounce', 'notify','$state', "$sce"];

function IDCtrl($scope, $rootScope, $http, $stateParams, $filter, $window, $timeout, $location, $upload, localStorageService, metadatautil, $q, $document, $uibModal, metaHelper, cookieStore, LOCALES, debounce, notify, $state, $sce) {


    if (angular.element('#ftct').hasClass('footercontainer')) {
        angular.element('#ftct').removeClass('footercontainer');
        angular.element('#ftct').addClass('hidden');
    }
    if (angular.element('#hdfctd').hasClass('header-sm')) {
        angular.element('#hdfctd').removeClass('header-sm');
        angular.element('#hdfctd').addClass('hidden');
    }
    if (angular.element('#redcdz').hasClass('header-sm-black2')) {
        angular.element('#redcdz').removeClass('header-sm-black2');
        angular.element('#redcdz').addClass('hidden');
    }

    var langPref = cookieStore.getCookie('lang_pref');

    console.log("$window.inner height", $window.innerHeight);

    $scope.dataAvailableAtLevel = undefined;




    var metaService = function(query) {
        traceLog("discover-meta", "called-> metaService with query as ", query);
        var pageDescription = ''
        var keyWords = ""
        var metaOgImage = "ogiconoglobe.png";
        var metaEEtitle = '';
        if (query.establishment) {
            metaOgImage = $scope.esta_main_photo;
            metaEEtitle = query.establishment + ' ' + query.cityId + ' ' + query.countryId;
            pageDescription = $filter('translate')('views.estameta_beforename');
            pageDescription += ' ' + query.establishment + ' ' + query.cityId + ' ' + query.countryId + ' ';
        } else {
            // format metaEEtitle based on query paramaters
            query.in ? metaEEtitle = query.in : '';
            query.cityId ? metaEEtitle += ' ' + query.cityId : '';
            query.countryId ? metaEEtitle += ' ' + query.countryId : '';
            query.cat ? metaEEtitle += ' ' + $filter('translate')(query.cat).replace('<br>', '') : '';
            query.genre ? metaEEtitle += ' ' + $filter('translate')('views.and') + ' ' + $filter('translate')(query.genre).replace('<br>', '') : '';

            // format page description based on query paramaters
            pageDescription = $filter('translate')('views.estameta_beforename');
            query.cat ? pageDescription += ' ' + $filter('translate')(query.cat).replace('<br>', '') : '';
            query.genre ? pageDescription += ' ' + $filter('translate')('views.and') + ' ' + $filter('translate')(query.genre).replace('<br>', '') : '';
            query.in ? pageDescription += ' ' + query.in : '';
            query.cityId ? pageDescription += ' ' + query.cityId : '';
            query.countryId ? pageDescription += ' ' + query.countryId : '';
        }



        var metaData = {
            pageTitle: metaEEtitle,
            metaKeywords: keyWords,
            metaDescription: pageDescription,
            metaOgImage: metaOgImage
        };
        traceLog("discover-load", "metaData is ", metaData);
        metadatautil.metaInformation(metaData);
    };


    $scope.ee_show = true;

    $scope.getEstaEEprofile = function(esta_id, ev, background, loadEvent, event_id, is_related, related_id) {
        traceLog('discover-seo', 'getEstaEEprofile() called with esta_id as', esta_id)
        $scope.maploading = true;
        delete $scope.estaId;
        $scope.estaId = esta_id;

        $scope.getUserDetail();
        return $http.post('/establishment/getEEProfile', {
            estaId: esta_id
        }).then(function(res) {
            var data = res.data;
            if (query.rD) {
                // As query contains referid this is a SEO hit for establishment we will use latitude/longitude of establishment to draw map
                var requestInfo = {
                    lat: data.data.lat,
                    long: data.data.lng
                };
                $scope.loadPromotionsOnDragMap(requestInfo);
                $scope.loadHangingOrSkyScrapperPromotionsOnDragMap(requestInfo, 'is_hanging');
                $scope.loadHangingOrSkyScrapperPromotionsOnDragMap(requestInfo, 'is_skyscrapper');
                $scope.drawMap(data.data.lat, data.data.lng, 10, true)
            }
            $rootScope.noScroll = 'no-scroll';
            $scope.establishmentDetails = data.data;
            var estaname = $scope.establishmentDetails.name.replace(/\s+/g, '-');
            $location.search('establishment', estaname);
            if (background) {
                $rootScope.getProfileInBackground(ev);
            } else {
                $scope.ee_show = false;
                $scope.ee_for = "esta";
                $location.search('rD', esta_id);
                $location.search('event', null);
                $location.search('related', null);
                $rootScope.getProfile(ev);
            }
            $scope.name = data.data.name;
            $scope.establish_url = (data.data.establish_url != null) ? data.data.establish_url : "Not Available";
            $scope.establish_phone = data.data.establish_phone;
            $scope.address = (data.data.address1) ? data.data.address1 + ', ' : '' + (data.data.address2) ? data.data.address2 + ', ' : '';
            $scope.address_complete = data.data.cityId + ',' + data.data.countryId;
            $scope.up_events = data.data.up_events;
            for (var i = 0; i < $scope.up_events.length; i++) {
                var start_date = new Date($scope.up_events[i].start_date);
                $scope.up_events[i].date = start_date;
                $scope.up_events[i].start_date = {
                    day: start_date.getDate(),
                    month: $filter('date')(start_date, "MMMM"),
                    year: start_date.getFullYear()
                };
            }
            $scope.establish_description = data.data.establish_description;
            if ($scope.metaType && $scope.metaType == 'establishment') {
                $rootScope.metaDescription = data.data.establish_description;
                delete $scope.metaType;
            }
            var langPref = cookieStore.getCookie('lang_pref');
            if (langPref) {
                var locale = LOCALES.locales[langPref];
            } else {
                var locale = LOCALES.locales['en_US'];
            }
            if (data.data.establish_locale && locale[0] == data.data.establish_locale) {
                $scope.name = data.data.location_i;
                $scope.establish_description = data.data.establish_description_i;
            }
            $scope.first_hour = (data.data.first_start_day && data.data.first_end_day && data.data.first_open_time && data.data.first_close_time) ? (data.data.first_start_day + " - " + data.data.first_end_day + " " + data.data.first_open_time + " - " + data.data.first_close_time) : "Not Available";
            $scope.second_hour = (data.data.second_start_day && data.data.second_end_day && data.data.second_start_time && data.data.second_close_time) ? (data.data.second_start_day + " - " + data.data.second_end_day + " " + data.data.second_start_time + " - " + data.data.second_close_time) : "Not Available";
            $scope.estaPhotos = data.data.photos;
            $scope.estaAudios = data.data.audios;
            $scope.estaVideos = data.data.videos;
            $scope.comments_esta = data.esta_comments;
            console.log("comments---->>>", $scope.comments_esta);
            if ($scope.comments_esta.length > 0) {
                for (var i = 0; i < $scope.comments_esta.length; i++) {
                    var date = $scope.comments_esta[i].comment_date.split('T');
                    $scope.comments_esta[i].comment_date = date[0];
                }
            }
            $scope.esta_main_photo = data.data.esta_main_photo;
            $scope.user_profile_pic = data.data.user_pic;
            var address = data.data.address1 + "," + data.data.cityId + "," + data.data.stateId + "," + data.data.countryId;
            var url_link = "https://" + window.location.host + "?in=" + $location.search().in + "&at=" + $location.search().at + "&rD=" + $location.search().rD + "&establishment=" + $location.search().establishment;
            $scope.url_to_link = url_link.replace(/ /g, "%20");
            $scope.url_to_share = window.encodeURIComponent(url_link);
            $scope.share_img_src = angular.element(document.querySelector('.banImg img')).attr("src");
            $scope.host = location.hostname;
            angular.element("#li_old").show();
            angular.element("#li_new").hide();
            $scope.social = data.social;
            $scope.maploading = false;
            if($scope.establishmentDetails.is_live  && !$scope.isLiveEvent){
                $scope.liveStreamButtonClicked($scope.establishmentDetails, false);
                // $scope.openLiveStreamPopup($scope.establishmentDetails.eename, $scope.establishmentDetails.id);
            }
            metaService(Object.assign($location.search(), {
                cityId: data.data.cityId,
                countryId: (data.data.countryId == 'United States' ? data.data.stateId : data.data.countryId)
            }));
            if (typeof(loadEvent) != "undefined") {
                if (typeof(is_related) != "undefined" && typeof(related_id) != "undefined" && loadEvent) {
                    $http.post("/establishment/getrelateddetails", {
                        related_id: related_id
                    }).then(function(res) {
                        var relatedDetails = res.data;
                        if (relatedDetails['status']) {
                            var sendParam = {
                                is_related: is_related,
                                related_id: related_id,
                                event_id: event_id
                            };
                            $scope.getEventEEprofile(relatedDetails['main_event_id'], ev, false, null, sendParam);
                        }
                    });
                } else {
                    $scope.getEventEEprofile(event_id, ev);
                }
            }
        });
    };
 $rootScope.getProfile = function(e) {
        $scope.stopAudio();
        $("#clipPath1").find('circle').attr("r", 60).css('transition', "all 0s");
        $rootScope.eeView = false;
        $rootScope.eeExtra = "gallery";
        var cards = $(".new_ee_profile_container");
        cards.map(function(i, c) {
            var visibility = $(c).is(":visible");
            if (visibility && i > 0) {
                $(c).addClass('hide');
                eePopUpClose(i);
            }
        });
        $rootScope.closeEEExtra();
        if (window.innerWidth <= 1024 && window.innerWidth >= 801) {
            $scope.activateEventSlider = false;
        }
        eePopUp(e, 0);
    };
  
 $scope.copyIp = function() {
    alert('Share Link Copied');
    $("#ip").select();
    document.execCommand("Copy");
}



    $rootScope.showFooter = false;
}